// extracted by mini-css-extract-plugin
export default {"semi-bold":"useUpdateProductAvailability_semi-bold__yJvUl"};